import { render, staticRenderFns } from "./ResetPassword.vue?vue&type=template&id=77d17c98&"
import script from "./ResetPassword.vue?vue&type=script&lang=js&"
export * from "./ResetPassword.vue?vue&type=script&lang=js&"
import style0 from "./ResetPassword.vue?vue&type=style&index=0&id=77d17c98&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('77d17c98')) {
      api.createRecord('77d17c98', component.options)
    } else {
      api.reload('77d17c98', component.options)
    }
    module.hot.accept("./ResetPassword.vue?vue&type=template&id=77d17c98&", function () {
      api.rerender('77d17c98', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/authentication/ResetPassword.vue"
export default component.exports